import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment.development';
import { map, type Observable } from 'rxjs';
import { StorageDataAccess } from './storage.data-access';

export const TRANSPORTARE_FILTERS_KEY = 'transportare-filters';

const filterKeys = {
  1: 'gender',
  2: 'maritalStatus',
  3: 'jobPosition',
  4: 'area',
  5: 'office',
  6: 'paymentType',
  7: 'serviceType',
  8: 'clientType',
  9: 'messagingStatus',
  11: 'trackingStatus',
  12: 'packageType',
  13: 'guideType',
  15: 'guideStatus',
  16: 'deliveryDetails',
  17: 'reasonDetails',
  18: 'details',
  19: 'temporaryType',
  20: 'scheduleRegime',
} as const;

interface FilterResponse {
  Descripcion: string;
  Grupo: number;
  GrupoDes: string;
  IdTablaGeneral: number;
}

type FilterKeyValues = (typeof filterKeys)[keyof typeof filterKeys];

export type Filter = { id: number; label: string };

type Filters = {
  [k in FilterKeyValues]: Filter[];
};

@Injectable({
  providedIn: 'root',
})
export class FiltersDataAccess {
  private _http = inject(HttpClient);

  private _url = environment.apiUrl;

  private _storage = inject(StorageDataAccess);

  get filters(): Filters {
    return this._storage.getItem(TRANSPORTARE_FILTERS_KEY);
  }

  getInitialFilters(): Observable<Filters> {
    return this._http
      .get<{ data: FilterResponse[] }>(`${this._url}/tablaGeneral/0`)
      .pipe(
        map((response) => response.data),
        map((response) => {
          const filters: Filters = {
            gender: [],
            maritalStatus: [],
            jobPosition: [],
            area: [],
            office: [],
            paymentType: [],
            serviceType: [],
            clientType: [],
            messagingStatus: [],
            trackingStatus: [],
            packageType: [],
            guideType: [],
            guideStatus: [],
            deliveryDetails: [],
            reasonDetails: [],
            details: [],
            temporaryType: [],
            scheduleRegime: [],
          };
          response.forEach((item) => {
            const key = filterKeys[item.Grupo as keyof typeof filterKeys];
            if (key) {
              filters[key] = [
                ...filters[key],
                { id: item.IdTablaGeneral, label: item.Descripcion },
              ];
            }
          });
          return filters;
        }),
      );
  }
}
